var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1584 11.1748L11.1834 17.1498C11.0286 17.3048 10.8448 17.4277 10.6425 17.5116C10.4402 17.5955 10.2233 17.6386 10.0042 17.6386C9.78522 17.6386 9.56834 17.5955 9.36601 17.5116C9.16368 17.4277 8.97987 17.3048 8.82508 17.1498L1.66675 9.99984V1.6665H10.0001L17.1584 8.82484C17.4688 9.13711 17.6431 9.55953 17.6431 9.99984C17.6431 10.4401 17.4688 10.8626 17.1584 11.1748V11.1748Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 5.8335H5.84159",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.180a75505201f77c8e81dd23bae45211.svg";
export { ForwardRef as ReactComponent };